<template>
  <div class="commondityList-view">
    <div class="list-header">
      <div class="header-left">
        <span>{{$t('ctCommodity.commodityPrice')}}</span>
      </div>
      <div class="header-right">
        <el-input
          style="width: 200px; margin-right: 40px"
          v-model="likeCommodity"
          size="small"
          :placeholder="$t('ctCommodity.search')"
          @input="handleSearch"
          clearable>
          <i slot="prefix" class="iconZma icon-sousuo1" style="line-height: 32px"></i>
        </el-input>
        <i class="iconfont el-icon-arrow-up" style="color: #7996F5;" @click="toggle"></i>
      </div>
    </div>
    <el-table
      v-loadmore="infiniteLoad"
      class="themeBlue kLineTable"
      :data="cdList"
      ref="list"
      height="300">
      <template slot="append" v-if="cdList.length>10 && loadOver">
        <p class="loadOver">{{$t('ctCommodity.loadOver')}}</p>
      </template>
      <el-table-column min-width="150" :label="$t('ctCommodity.commodity')">
        <template slot-scope="scope">
          <a class="title-primary" @click="handleDetail(scope)">{{scope.row.name}}</a>
        </template>
      </el-table-column>
      <el-table-column
        min-width="85"
        prop="last"
        :label="$t('ctCommodity.last')">
      </el-table-column>
      <el-table-column
        min-width="85"
        prop="high"
        :label="$t('ctCommodity.high')">
      </el-table-column>
      <el-table-column
        min-width="85"
        prop="low"
        :label="$t('ctCommodity.low')">
      </el-table-column>
      <el-table-column
        min-width="85"
        :label="$t('ctCommodity.chg')">
        <template slot-scope="scope">
          <span :class="dealChg(scope.row.change)">{{ scope.row.change | formatChg }}</span>
        </template>
      </el-table-column>
      <el-table-column
        min-width="85"
        :label="$t('ctCommodity.chg_1')">
        <template slot-scope="scope">
          <span :class="dealChg(scope.row.changePercentage)">{{ scope.row.changePercentage | formatChg }}{{scope.row.changePercentage ==='-'? '':'%'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        prop="volume"
        :label="$t('ctCommodity.volume')">
        <!--          <template slot-scope="scope">-->
        <!--            {{scope.row.volume | formatNum}}-->
        <!--          </template>-->
      </el-table-column>
    </el-table>

    <el-dialog
      class="c-dialog cp-dialog"
      :title="commodityTitle"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      @close="handleClose"
      custom-class="c-scroll"
      width="1140px">
      <div class="commodity-price">
        <div v-if="isNew" class="cp-h">
          <div class="cp-left" :class="latestMsg.isUp">
            <h3>{{latestMsg.last}} <span :class="latestMsg.isUp">{{latestMsg.change | formatChg}} ({{latestMsg.changePercentage | formatChg}}%)</span></h3>
            <p><i class="iconZma icon-shijian"></i>{{latestMsg.time}} - Real-time derived data. Currency in {{categoryMsg.priceUnit}}</p>
          </div>
          <div class="cp-center">
            <p><span>{{$t('ctCommodity.group')}}</span>{{categoryMsg.categoryName}}</p>
            <p><span>{{$t('ctCommodity.unit')}}</span>1 {{categoryMsg.weightUnit}}</p>
          </div>
          <div class="cp-down">
            <i @click="handleDown" class="iconZma icon-xiazai"></i>
          </div>
        </div>

        <div class="cp-h old" v-else>
          <div class="cp-center">
            <p><span>{{$t(`ctTrade.lastUpdate`)}}</span>{{commodityLastDate}}</p>
          </div>
          <div class="cp-down">
            <i @click="handleDown" class="iconZma icon-xiazai"></i>
          </div>
        </div>
        <!--            商品走势头部信息-->

        <div class="cp-body" v-loading="firstRequest && chartLoad">
          <el-tabs v-if="isNew" class="cp-tabs" v-model="period" @tab-click="tabChange">
            <el-tab-pane v-for="tab in cpTabsList" :key="tab.label" :label="tab.label" :name="tab.name"></el-tab-pane>
            <el-tab-pane name="6">
              <div slot="label">
                <el-select v-model="moreType" :placeholder="$t('ctCommodity.more')" @change="moreChange">
                  <el-option
                    v-for="item in moreOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-tab-pane>
          </el-tabs>

          <el-tabs v-else class="cp-tabs old" v-model="timeType" @tab-click="tabChange">
            <el-tab-pane v-for="tab in cpTimeList" :key="tab.label" :label="tab.label" :name="tab.name"></el-tab-pane>
          </el-tabs>
          <!--        时间tab切换  @mouseover="echartsOver"-->

          <div class="chart-box" @mouseleave="echartsLeave" @mousemove="echartsMove">
            <div class="chart" ref="dialogEchart"></div>

            <div v-if="isNew && period !== '1D' && tooltipData" class="legend-box">
              <p class="p1"><i class="iconZma icon-legend"></i>MA5：<span>{{tooltipData.ma5 | formatNum(3)}}</span></p>
              <p class="p2"><i class="iconZma icon-legend"></i>MA10：<span>{{tooltipData.ma10 | formatNum(3)}}</span></p>
              <p class="p3"><i class="iconZma icon-legend"></i>MA20：<span>{{tooltipData.ma20 | formatNum(3)}}</span></p>
              <p class="p4"><i class="iconZma icon-legend"></i>MA30：<span>{{tooltipData.ma30 | formatNum(3)}}</span></p>
            </div>
            <!--          k线图 图例  -->

            <div v-if="tooltipShow && tooltipData" class="tooltip-box" :class="{left:xPos,old:!isNew}">
              <p v-if="tooltipData.detailTime">{{tooltipData.detailTime}}</p>
              <template v-if="isNew">
                <div v-if="period === '1D'">
                  <p>{{$t('ctCommodity.price')}} <span :class="dealStatus(tooltipData.priceChangeStatus)">{{tooltipData.price | formatNum(3)}}</span></p>
                </div>
                <div v-else>
                  <p>{{$t('ctCommodity.open')}} <span :class="dealStatus(tooltipData.openStatus)">{{tooltipData.open | formatNum(3) }}</span></p>
                  <p>{{$t('ctCommodity.high')}} <span :class="dealStatus(tooltipData.hightStatus)">{{tooltipData.hight | formatNum(3) }}</span></p>
                  <p>{{$t('ctCommodity.low')}} <span :class="dealStatus(tooltipData.lowStatus)">{{tooltipData.low | formatNum(3) }}</span></p>
                  <p>{{$t('ctCommodity.close')}} <span :class="dealStatus(tooltipData.closeStatus)">{{tooltipData.close | formatNum(3) }}</span></p>
                  <p>{{$t('ctCommodity.change')}} <span :class="dealStatus(tooltipData.changeStatus)">{{tooltipData.change | formatNum(3) | formatChg }}</span></p>
                  <p>{{$t('ctCommodity.change_1')}} <span :class="dealStatus(tooltipData.changePercentageStatus)">{{tooltipData.changePercentage | formatNum(3) | formatChg }}%</span></p>
                </div>
                <p>{{$t('ctCommodity.volume')}} <span>{{tooltipData.volume | formatNum(3) }}</span></p>
                <p>{{$t('ctCommodity.openInterest')}} <span>{{tooltipData.openInterest | formatNum(3) }}</span></p>
              </template>
              <template v-else>
                <p>{{$t('ctCommodity.open')}} <span>{{tooltipData.open | formatNum(3)}}</span></p>
                <p>{{$t('ctCommodity.high')}} <span>{{tooltipData.high | formatNum(3)}}</span></p>
                <p>{{$t('ctCommodity.low')}} <span>{{tooltipData.low | formatNum(3)}}</span></p>
                <p>{{$t('ctTrade.settle')}} <span>{{tooltipData.settle | formatNum(3)}}</span></p>
                <p>{{$t('ctCommodity.volume')}} <span>{{tooltipData.volume | formatNum(3)}}</span></p>
                <p>{{$t('financingFundDetail.prevDayOpenInterest')}} <span>{{tooltipData.prevDayOpenInterest | formatNum(3)}}</span></p>
              </template>
            </div>
            <!--          右上角提示信息-->

            <div v-if="isNew" class="vol-box">VOL {{tooltipData && tooltipData.volume | formatNum(3)}}</div>
          </div>
          <!--        图表-->

        </div>
        <!--            商品走势折线图-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import index from "./index.js"
export default index
</script>

<style lang="scss">
.commondityList-view{
  border-top: 1px solid #EAEAEA;
  //height: 390px;
  .list-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #EAEAEA;
    .el-input__inner{
      border-color: #D4E1FF;
    }
    .iconZma{
      color: #333333;
    }
  }
  .themeBlue{
    border-left: 1px solid #EAEAEA;
    border-right: 1px solid #EAEAEA;
    .title-primary{
      color: #0073FF;
      padding: 0 5px;
    }

    .el-table__header-wrapper{
      background-color: #f8fafd;
      //width: 1008px;
    }
    th{
      text-align: center;
      border-right: 1px solid #EAEAEA;
      width: 146px;

    }
    td{
      text-align: center;
      border-right: 1px solid #EAEAEA;
      width: 146px;

    }
  }
  .header-left{
    color: #333333;
    font-size: 16px;
    line-height: 50px;
  }
  .header-right{

  }
  .up {
    color: #13AF6B !important;
  }
  .down {
    color: #E44245 !important;
  }
}



.commodity-price {
  min-height: 500px;
  padding-bottom: 30px;

  .cp-h {
    margin-top: -10px;
    height: 71px;
    /*border-bottom: 1px solid #EAEAEA;*/
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .cp-left {
      width: 710px;
      box-sizing: border-box;
      &.up, &.down{
        padding-left: 34px;
      }
      &.up {
        background: url("../../assets/images/icon-up.png") no-repeat left 4px;
      }
      &.down {
        background: url("../../assets/images/icon-down.png") no-repeat left 4px;
      }

      h3 {
        line-height: 30px;
        font-size: 24px;
        color: #333333;
        font-weight: bold;
        height: 30px;
        display: flex;
        margin-bottom: 13px;

        span {
          font-size: 16px;
          color: #333333;
          display: inline-block;
          margin-left: 10px;
        }
      }

      p {
        font-size: 14px;
        color: #999999;
        display: flex;
        line-height: 20px;

        i {
          color: #0073FF;
          font-size: 20px;
          margin-right: 5px;
        }
      }
    }

    .cp-center {
      padding-top: 5px;
      width: 320px;

      p {
        line-height: 20px;
        span {
          border-right: 1px solid #D1D0D8;
          display: inline-block;
          width: 70px;
          padding: 0 10px;
          box-sizing: border-box;
          color: #666666;
          margin-right: 20px;
        }

        & + p {
          span {
            padding-top: 10px;
          }
        }
      }
    }

    .cp-down {
      display: flex;
      align-items: center;
      margin-top: -10px;

      i {
        font-size: 24px;
        color: #0073FF;

        &:hover {
          cursor: pointer;
        }
      }
    }

    &.old{
      height: 40px;
      justify-content: flex-end;
      .cp-center{
        /*width: 205px;*/
        p span {
          width:105px;
        }
      }
    }
  }
  /*商品走势 头部信息*/

  .cp-body {
    border: 1px solid #EAEAEA;
    .el-loading-mask{
      background-color: rgba(255,255,255,0.01);
    }
    .cp-tabs {
      height: 30px;

      .el-tabs__active-bar {
        display: none;
      }

      .el-tabs__item {
        padding: 0 12px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #666666;

        &.is-active {
          color: #0073FF;
          border-bottom: 1px solid #0073FF;
        }

        &:hover {
          color: #0073FF;
        }

        &:last-child {
          padding: 0;
        }
      }

      .el-tabs__nav-wrap::after {
        height: 1px;
        background-color: #EAEAEA;
      }

      .el-select {
        height: 29px;
        width: 64px;
      }

      .el-input__inner {
        border: none;
        height: 29px;
        line-height: 29px;
        padding: 0 24px 0 12px;
        background-color: transparent;
      }

      .el-input__icon {
        line-height: 30px;
        height: 30px;
      }
      &.old{
        .el-tabs__item {
          &:last-child {
            padding: 0 12px;
          }
        }
      }
    }

    .chart-box {
      width: 100%;
      height: 552px;
      position: relative;

      .chart {
        width: 100%;
        height: 552px;
      }
    }

    .legend-box{
      position: absolute;
      left:10px;
      right: 10px;
      top: 10px;
      height: 20px;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      p{
        font-size: 12px;
        display: flex;
        i{
          margin-right: 4px;
          font-size: 12px;
          transform: scale(0.8);
          font-weight: normal;
        }
        &+p{
          margin-left: 38px;
        }
        &.p1{
          color: #E71515;
        }
        &.p2{
          color: #C739D1;
        }
        &.p3{
          color: #E1AB2C;
        }
        &.p4{
          color: #0073FF;
        }
      }
    }

    .tooltip-box {
      position: absolute;
      right: 43px;
      top: 40px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.10);
      width: 200px;
      min-height: 100px;
      background-color: #ffffff;
      box-sizing: border-box;
      padding: 7px 10px;
      transition: all 0.5s;
      &.left{
        right:auto;
        left: 92px;
      }
      &.old{
        top: 18px;
        right: 18px;
        &.left{
          left: 62px;
        }
      }
      p {
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #666666;

        span {
          color: #333;
          text-align: right;
        }

      }
    }

    .vol-box {
      position: absolute;
      left: 0;
      top: 79%;
      right: 0;
      background: #EAEAEA;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #666666;
      padding: 0 20px;
    }
  }

}

.cp-dialog .el-dialog.c-scroll .el-dialog__body{
  max-height: 680px;
  padding: 20px 25px 0;
}


.c-dialog{
  .el-dialog{
    &.c-scroll{
      margin-top: 30px !important;
      .el-dialog__body{
        max-height: 680px;
        overflow-y: auto;
      }
    }
    .el-dialog__header{
      background: #30344B;
      padding: 13px 30px;
      height: 60px;
      box-sizing: border-box;
    }
    .el-dialog__title{
      font-size: 16px;
      color: #FFFFFF;
      display: inline-block;
      line-height: 34px;
      border-left: 2px solid #4E94CF;
      padding-left: 10px;
    }
    .el-dialog__headerbtn{
      right: 26px;
    }
    .el-dialog__close{
      color: #ffffff;
      font-size: 22px;
    }
    .el-dialog__footer{
      text-align: center;
      padding: 30px 40px 20px;
    }
    .el-dialog__body{
      padding:20px 30px 0;
    }
  }

  &.no-tit{
    .el-dialog{
      border-radius: 4px;
      overflow: hidden;
      .el-dialog__headerbtn{
        top: 8px;
        right: 6px;
      }
      .el-dialog__header{
        background-color: #ffffff;
        padding: 0 10px;
        height: 40px;
      }
      .el-dialog__close{
        color: #A9B0CE;
      }
      .el-dialog__body{
        padding-top: 0;
        min-height: 40px;
      }
    }
  }

  .pure-text{
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    //border-bottom: 1px solid #EAEAEA;
    text-align: left;
    p{
      word-break: break-word;
      white-space: pre-line;
      line-height: 20px;
    }
    .subBg{
      font-size: 12px;
      color: #666666;
      background: #F7FAFC;
      border-radius: 2px;
      line-height: 16px;
      padding: 10px;
      margin-top: 20px;
    }
  }

  .head-share{
    color: #ffffff;
    font-size: 20px;
    position: absolute;
    right: 74px;
    top: 18px;
    &:hover{
      cursor: pointer;
    }
  }

  .head-dealNumber{
    color: #FFFFFF;
    font-size: 12px;
    position: absolute;
    right: 73px;
    top: 13px;
    float: right;
  }
  .head-date{
    color: #FFFFFF;
    font-size: 12px;
    position: absolute;
    right: 74px;
    top: 35px;
    float: right;
  }
}

@media screen and (max-width: 1440px){
  .cp-dialog {
    .el-dialog {
      &.c-scroll {
        .el-dialog__body {
          max-height: 460px;
          overflow-y: auto;
        }
      }
    }
  }
}
.iconZma{
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.loadOver{
  text-align: center;
  padding: 5px 0;
  color: #999999;
}
</style>
